import { render } from "./LiveData.vue?vue&type=template&id=79bf0009&scoped=true"
import script from "./LiveData.vue?vue&type=script&lang=js"
export * from "./LiveData.vue?vue&type=script&lang=js"

import "./LiveData.vue?vue&type=style&index=0&id=79bf0009&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bf0009"]])

export default __exports__